import React, { Fragment } from 'react'
import MEModal from '../../components/MEModal'
import { Button, MenuItem } from 'react-bootstrap'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { removeCourseMember } from '../actions'
import ButterToast, { Cinnamon } from 'butter-toast'

class RemoveCourseMemberModal extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      removeCourseMemberModalOpen: false,
    }
    this.toggleRemoveCourseMemberModal =
      this.toggleRemoveCourseMemberModal.bind(this)
    this.submitRemoveCourseMember = this.submitRemoveCourseMember.bind(this)
  }

  toggleRemoveCourseMemberModal() {
    this.setState({
      removeCourseMemberModalOpen: !this.state.removeCourseMemberModalOpen,
    })
  }

  async submitRemoveCourseMember() {
    this.toggleRemoveCourseMemberModal()
    let data = this.props.filters
    data.user_id = this.props.user_id
    data.archivedPageNum = this.props.currentArchivePage
    data.pageNum = this.props.currentCourseMemPage

    let response = await this.props.removeMember(data)
    if (response.status === 200) {
      ButterToast.raise({
        content: (
          <Cinnamon.Crunch
            title="Successfully Removed"
            content="Successfully removed from course."
            scheme={Cinnamon.Crisp.SCHEME_GREY}
          />
        ),
      })
    } else {
      ButterToast.raise({
        content: (
          <Cinnamon.Crunch
            title="Error"
            content={response.error}
            scheme={Cinnamon.Crisp.SCHEME_RED}
          />
        ),
      })
    }
  }

  render() {
    return (
      <Fragment>
        <MenuItem
          onClick={this.toggleRemoveCourseMemberModal}
          className="me-list-item"
        >
          <i className="fal fa-minus-circle fa-fw color_teal mr-2" /> Remove
        </MenuItem>
        <MEModal
          show={this.state.removeCourseMemberModalOpen}
          close={this.toggleRemoveCourseMemberModal}
          title="Remove From Course"
        >
          <form onSubmit={e => e.preventDefault()}>
            <p>
              Are you sure you want to remove <i>{this.props.user_full_name}</i>{' '}
              from this course?
            </p>
            <Button
              className="mt-3 btn-myed btn-danger-myed"
              type="button"
              bsStyle="danger"
              onClick={this.submitRemoveCourseMember}
            >
              Remove
            </Button>
          </form>
        </MEModal>
      </Fragment>
    )
  }
}

RemoveCourseMemberModal.propTypes = {
  user_id: PropTypes.string,
  user_full_name: PropTypes.string,
  removeMember: PropTypes.func,
  filters: PropTypes.object,
}

const mapStateToProps = state => {
  return {
    peopleData: state.peopleRowData,
    courseLms: state.courseLms,
    filters: state.filters,
    currentCourseMemPage: state.currentCourseMemPage,
    currentArchivePage: state.currentArchivePage,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    removeMember: userId => dispatch(removeCourseMember(userId)),
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RemoveCourseMemberModal)
